import { getDocument, getGetDocumentQueryKey } from '@modusign/openapi-client-external-document';
import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

import { ExternalDocument } from '../../types/ExternalDocument';

export default function useExternalDocument(
  externalDocumentId: string,
  options?: { onError?: (error: AxiosError) => void; retry?: number | boolean; enabled?: boolean }
) {
  const workspaceId = useWorkspaceId();
  const result = useQuery<ExternalDocument, AxiosError>(
    getGetDocumentQueryKey(workspaceId, externalDocumentId),
    async (): Promise<ExternalDocument> =>
      // TODO: @atobaum 타입 수정
      getDocument(workspaceId, externalDocumentId) as Promise<ExternalDocument>,
    { ...options, enabled: !!workspaceId && (options?.enabled ?? true) }
  );

  return result;
}
